import { createReducer, on } from '@ngrx/store'
import { AuthActions } from './action-types'
import jwt_decode from 'jwt-decode'

export const initState = {
    accessToken: {
        token: null,
        username: null,
        name: null,
        projectKey: null,
        authorizations: [],
        adminPermission: null,
        expiration: null
    }
}

export const authReducer = createReducer(
    initState,
    on(AuthActions.reset, () => {
        return {...initState}
    }),
    on(AuthActions.authSetAccessToken, (state, props) => {
        const decoded = jwt_decode(props.accessToken)

        const token = {
            token: props.accessToken,
            username: decoded['sub'],
            name: decoded['name'],
            projectKey: decoded['p_key'],
            authorizations: decoded['auths'],
            adminPermission: decoded['admin'],
            expiration: decoded['exp']
        }

        return {...state, accessToken: token}
    })
)

export interface IAuthState {
    accessToken: IAuthAccessToken;
}

export interface IAuthAccessToken {
    token: string;
    username: string;
    name: string;
    projectKey: string;
    authorizations: any[];
    adminPermission: boolean;
    expiration: string;
}